import React, { useEffect, createRef, useState } from "react";
import LayoutSection from "../../layouts/layoutSection";
import { useInView } from 'react-intersection-observer';
import TitreSection from "../ui/typographic/titreSection";
import TextSection from "../ui/typographic/textSection";
import Legend from "../ui/typographic/legend";
import {Vs} from "../../svgIcons/vs"

const Positionnement = ({ lineStep, content, colorBckgd }) => {
  let animationContainer = createRef();
  let animationContainer2 = createRef();
  const { ref: divdRef, inView: divIsVisible } = useInView({
    threshold: .5,
    triggerOnce: true
  });
  const [isMobile, setIsMobile] = useState(true)
  const [lottie, setLottie] = useState(null);
  const [animation1, setAnimation1] = useState(null)
  const [animation2, setAnimation2] = useState(null)

  useEffect(() => {
    if (window.innerWidth >= 768) {
      import('../../../animations/positionnement.json')
      .then(anim1 =>
        setAnimation1(anim1)
      );

      import('../../../animations/objectif.json')
      .then(anim2 =>
        setAnimation2(anim2)
      );
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth >= 768) {
      import('lottie-web/build/player/lottie_light.min.js')
      .then(lottie_lightMin =>
        setLottie(lottie_lightMin)
      );
    }
  }, []);


  useEffect(() => {
    if (window.innerWidth >= 768) {
      setIsMobile(false)
      if (divIsVisible && lottie) {
        const anim = lottie.loadAnimation({
          container: animationContainer.current,
          renderer: "svg",
          loop: false,
          autoplay: false,
          animationData: animation1,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
            className: "lottie-svg-class",
            id: "lottie-svg-id"
          }
        });
        const anim2 = lottie.loadAnimation({
          container: animationContainer2.current,
          renderer: "svg",
          loop: false,
          autoplay: false,
          animationData: animation2,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
            className: "lottie-svg-class",
            id: "lottie-svg-id"
          }
        });
        if (divIsVisible) {
          anim.play()
          anim.addEventListener('complete', function () {
            anim2.play()
          })
        }
        return () => {
          anim.destroy(); // optional clean up for unmounting
          anim2.destroy(); // optional clean up for unmounting
        }
      }
    }
  }, [divIsVisible, animationContainer, animation1, animation2, lottie, animationContainer2]);

  return (
    <LayoutSection
      lineStep={lineStep}
      type=''
      colorBckgd='x-light-violet-bckd'
      extraclass='inherit-min-height '
    >
      <div className="flex flex-col align-middle">
        <div className="mb-12 md:flex md:justify-center md:items-center md:gap-12">
          <div ref={divdRef} className=" md:basis-1/2 ">
            <Legend
              content={content.soustitre}
              inView={divIsVisible}
              reference={divdRef}
            />
            <TitreSection
              content={content.titre}
              size={5}
              inView={divIsVisible}
              reference={divdRef}
            />
          </div>
          <div ref={divdRef} className=" text-sm md:basis-1/2">
            <TextSection
              content={content.description}
              size="s"
              inView={divIsVisible}
              reference={divdRef}
            />
          </div>
        </div>
        {
          !isMobile ?
          <div className="schema-compare md:flex md:justify-center md:items-center md:gap-8 md:h-80">
            <div className="relative flex justify-center items-center light-violet-bckd h-full mb-12 md:m-0 md:flex-1 md:bg-transparent lg:bg-slate-200">
              <span className="absolute text-sm -top-7 bleu font-medium">Votre infrastructure télécom actuelle</span>
              <div className="animation-container mx-auto h-4/6 max-w-md" ref={animationContainer} />
            </div>
            <div className="hidden lg:block md:flex-0">
              <Vs size={100} color='#808bef' />
            </div>
            <div className="relative flex justify-center items-center positionnement-napsis light-violet-bckd h-full pt-8 md:pt-0 mb-8 md:m-0 md:before md:flex-1 md:bg-transparent lg:bg-slate-200">
              <span className="absolute text-sm -top-7 bleu font-medium">Votre infrastructure télécom avec Napsis</span>
              <div className="animation-container mx-auto max-w-xs" ref={animationContainer2} />
            </div>
          </div>
          : ''
        }
      </div>
    </LayoutSection>
  )
}


export default Positionnement
